export default async function (newId, type, item, parent) {
  // can return object like { identifier: ..., name: ... }
  // name is not mandatory
  return null
}
